import React from 'react';

const FileChangeDetailCard = ({
  label,
  value,
  valueClassName = '',
}) => (
  <div className="min-w-0 rounded-xl border border-border/20 bg-transparent px-4 py-3">
    <div className="text-[11px] font-semibold uppercase tracking-[0.14em] text-muted-foreground">
      {label}
    </div>
    <div className={`mt-2 text-[13px] font-medium text-foreground ${valueClassName}`}>
      {value}
    </div>
  </div>
);

export default FileChangeDetailCard;
